import React from "react";
import Cart from "../../components/Cart";
function CartSol() {
    return <div>
        <Cart/>
    </div>;
}

export default CartSol;
